import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Created At",
  "Raised By",
  "Related To",
  "Status",
  "Actions",
];

const FarmQueryTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  let userData = useSelector((store) => store.login.user);
  const userId = userData.UserId;
  const userRole = userData.Role;

  const isAdmin = [
    process.env.REACT_APP_ROLE_ADMIN_S,
    process.env.REACT_APP_ROLE_ADMIN,
    process.env.REACT_APP_ROLE_OPS,
    process.env.REACT_APP_ROLE_AGRONOMIST,
    process.env.REACT_APP_ROLE_SALLE_ADMIN,
  ].includes(userRole);

  const filteredData = Array.isArray(data)
    ? isAdmin
      ? data
      : data.filter((item) => item.generatedById == userId)
    : [];

  const goToView = (id) => {
    navigate(`/agronomy-farm-support/view/${id}`);
  };

  const assignToMe = (id) => {
    performRequest("PATCH", `/farmSupport/updateQuery/${id}`, {
      assign: userId,
      assignedName: userData.Name,
      status: "being address",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Assigned successfully!");
          navigate(`/agronomy-farm-support/view/${id}`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item, index) => {
            const isAssigned = item.assign;
            return (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{extractDate(item.createdAt) || "N/A"}</td>
                <td>{item.generatedBy || "N/A"}</td>
                <td>{item.relatedTo || "N/A"}</td>
                <td>{item.status || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>

                  {isAdmin && (
                    <button
                      className="btn btn-sm px-3 m-0 ms-lg-2 btn-primary"
                      onClick={() => assignToMe(item.id)}
                      disabled={isAssigned}
                    >
                      {isAssigned ? "Assigned" : "Assign to me"}
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FarmQueryTable;
